var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partMeeting-container"},[_c('van-sticky',[_c('head-bar',{attrs:{"type":"primary","leftArrow":true,"left-text":"","title":"现场直播"},on:{"onClickLeft":_vm.onClickLeft}})],1),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticStyle:{"width":"100%","height":"auto"},attrs:{"id":"id_test_video"}})])
}]

export { render, staticRenderFns }